import { createAction } from 'redux-actions';
import { coalesce, hasValue } from '../../../utils/utils';
import { LOCATION_CHANGE } from '../authentication/authentication.module';

const SET_QUICK_SELL_SHOW_ALL_SELL_FUNDS = 'SET_QUICK_SELL_SHOW_ALL_SELL_FUNDS';

export default function quickSell(
  state = {
    quickSellAgreements: [],
    quickSellInitialized: false,
    quickSellType: 'MutualFund',
    showAllSellFunds: false,
  },
  { payload, type }
) {
  switch (type) {
    case LOCATION_CHANGE: {
      if (state.quickSellInitialized) {
        return state;
      }
      const productTypeCategory = /productTypeCategory?=?([\w-]+)?/.exec(
        window.location.search
      );
      const selectedAgreementIDs = /selectedAgreementIDs?=?([\w-]+)?/.exec(
        window.location.search
      );
      return {
        ...state,
        quickSellInitialized: true,
        quickSellAgreements: hasValue(selectedAgreementIDs)
          ? [selectedAgreementIDs[1]]
          : [],
        quickSellType: hasValue(productTypeCategory)
          ? coalesce(productTypeCategory[1], 'MutualFund')
          : 'MutualFund',
      };
    }
    case `${SET_QUICK_SELL_SHOW_ALL_SELL_FUNDS}_FULFILLED`: {
      const newState = {
        ...state,
        showAllSellFunds: payload,
      };
      if (payload) {
        newState.quickSellAgreements = [];
      }
      return newState;
    }
    default:
      return state;
  }
}

export const setShowAllSellFunds = (expanded) => {
  return (dispatch) => {
    const action = createAction(
      `${SET_QUICK_SELL_SHOW_ALL_SELL_FUNDS}_FULFILLED`
    )(expanded);
    dispatch(action);
  };
};
